import styled from "vue-styled-components";

export const Content = styled.div`
    .modal {
        z-index: 1049;
    }
    
    .modal-header {
        border: 0;
        padding-top: 2rem;
    }

    .modal-body {
        padding-bottom: 2rem;

        h2 {
            font-weight: normal;
            padding-inline: 2rem;
            line-height: 1.5;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }

        button {
            max-width: 200px;
            font-weight: 600;
        }
    }

    &.require-location {
        .modal {
            pointer-events: none;

            .modal-body {
                padding-top: 2rem;
            }
        }        
    }
`;
